"use client"
const CrmPauEnums = {
  // Sale or Lease
  saleOrLease: [
    { label: "Lease", value: "LEASE" },
    { label: "Sale", value: "SALE" }
  ],
  // An RE listing's type: a unit's sale/lease, or a property that isn't on the market yet
  listingSaleOrLease: [
    { label: "Lease", value: "LEASE" },
    { label: "Sale", value: "SALE" },
    { label: "Under Development", value: "UNDER_DEVELOPMENT" }
  ],

  // State of Repair
  stateOfRepair: [
    { label: "Excellent", value: "EXCELLENT" },
    { label: "Good", value: "GOOD" },
    { label: "Fair", value: "FAIR" },
    { label: "Poor", value: "POOR" }
  ],

  // Unit Types
  unitType: [
    { label: "Residential", value: "RESIDENTIAL" },
    { label: "Office", value: "OFFICE" },
    { label: "Industrial", value: "INDUSTRIAL" },
    { label: "Retail", value: "RETAIL" },
    { label: "Medical", value: "MEDICAL" },
    { label: "Food", value: "FOOD" },
    { label: "Event Space", value: "EVENT" },
    { label: "Storage/Warehouse", value: "STORAGE" },
    { label: "Other", value: "OTHER" }
  ],

  // Occupancy Roles
  occupancyRole: [
    { label: "Tenant", value: "TENANT" },
    { label: "Owner", value: "OWNER" },
    { label: "Subtenant", value: "SUBTENANT" },
    { label: "Vacant", value: "VACANT" }
  ],

  // Party Types
  partyType: [
    { label: "Business", value: "BUSINESS" },
    { label: "Individual", value: "CONTACT" }
  ],

  // Floor Values
  floor: [
    { label: "Ground Floor", value: "GROUND_FLOOR" },
    { label: "Floor 2", value: "FLOOR_2" },
    { label: "Floor 3", value: "FLOOR_3" },
    { label: "Floor 4", value: "FLOOR_4" },
    { label: "Floor 5", value: "FLOOR_5" },
    { label: "Upper Floor", value: "UPPER_FLOOR" },
    { label: "Entire Building", value: "ENTIRE_BUILDING" },
    { label: "Basement", value: "BASEMENT" },
    { label: "Vacant Lot", value: "VACANT_LOT" },
    { label: "Parking", value: "PARKING" }
  ],

  // Entrance From
  entranceFrom: [
    { label: "Street", value: "STREET" },
    { label: "Lobby", value: "LOBBY" },
    { label: "Rear", value: "REAR" },
    { label: "Garage", value: "GARAGE" },
    { label: "Alley", value: "ALLEY" },
    { label: "Other", value: "OTHER" }
  ],

  // Land Use Codes
  landUseCode: [
    { label: "Residential", value: "RESIDENTIAL" },
    { label: "Commercial", value: "COMMERCIAL" },
    { label: "Industrial", value: "INDUSTRIAL" },
    { label: "Mixed Use", value: "MIXED_USE" },
    { label: "Agricultural", value: "AGRICULTURAL" },
    { label: "Vacant", value: "VACANT" }
  ],

  addressTypes: [
    { label: "Building", value: "BUILDING" },
    { label: "Lot Subdivision", value: "LOT_SUBDIVISION" },
    { label: "Construction", value: "CONSTRUCTION" },
    { label: "Parking", value: "PARKING" },
    { label: "Entrance", value: "ENTRANCE" },
    { label: "Temporarily Closed", value: "TEMPORARILY_CLOSED" },
    { label: "Vacant Lot", value: "VACANT_LOT" },
    { label: "Fire Damage", value: "FIRE_DAMAGE" },
    { label: "Flood Damage", value: "FLOOD_DAMAGE" },
    { label: "Restricted Access", value: "RESTRICTED_ACCESS" },
    { label: "Other", value: "OTHER" }
  ],

  // Commercial building class
  buildingClass: [
    { label: "Class A", value: "A" },
    { label: "Class B", value: "B" },
    { label: "Class C", value: "C" },
    { label: "Class D", value: "D" }
  ],

  // Alternative Energy Types
  altEnergyType: [
    { label: "Solar", value: "SOLAR" },
    { label: "Wind", value: "WIND" },
    { label: "Hydro", value: "HYDRO" },
    { label: "Geothermal", value: "GEOTHERMAL" },
    { label: "Other", value: "OTHER" }
  ],

  // Tenant Readiness
  tenantReadinessCertificateStatus: [
    { label: "Active", value: "ACTIVE", hint: "The certificate of occupancy or readiness certification is current and valid." },
    { label: "Expired", value: "EXPIRED", hint: "The certificate has passed its validity period and may need renewal." },
    { label: "Unknown", value: "UNKNOWN", hint: "The current status of the certificate has not been verified." }
  ],
  tenantReadinessBuildout: [
    { label: "Turnkey", value: "TURNKEY", hint: "The space is fully built out and move-in ready with no additional construction needed." },
    { label: "Second Gen", value: "SECOND_GEN", hint: "Previously occupied space that retains the prior tenant's buildout and improvements." },
    { label: "Whitebox", value: "WHITEBOX", hint: "A finished shell with basic utilities, drywall, and ceiling in place but no custom buildout." },
    { label: "Shell", value: "SHELL", hint: "A raw, unfinished space requiring a full buildout including walls, flooring, and utilities." }
  ],
  tenantReadinessLeaseType: [
    { label: "NNN", value: "NNN", hint: "Tenant pays base rent plus all property taxes, insurance, and maintenance costs." },
    { label: "Modified Gross", value: "MODIFIED_GROSS", hint: "Tenant and landlord share operating expenses according to negotiated terms." },
    { label: "Full Service", value: "FULL_SERVICE", hint: "Landlord covers all operating expenses including taxes, insurance, and maintenance in one rental rate." }
  ],
  tenantReadinessAvailabilityTimeline: [
    { label: "Immediate", value: "IMMEDIATE", hint: "The space is available for occupancy right now with no waiting period." },
    { label: "30-60 Days", value: "DAYS_30_60", hint: "The space will be ready for occupancy within one to two months." },
    { label: "60-90 Days", value: "DAYS_60_90", hint: "The space will be ready for occupancy within two to three months." },
    { label: "90+ Days", value: "DAYS_90_PLUS", hint: "The space requires more than three months before it is ready for occupancy." },
    { label: "Contact Us", value: "CONTACT_US", hint: "Availability timing is flexible or uncertain — reach out for details." }
  ]
};

export default CrmPauEnums;
